const formatDate = (dbDate, format = 'default') => {
  const dateObj = new Date(dbDate);

  if (isNaN(dateObj.getTime())) {
    throw new Error('Invalid date provided');
  }

  const yyyy = dateObj.getFullYear();
  const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
  const dd = String(dateObj.getDate()).padStart(2, '0');
  const normalized = `${yyyy}-${mm}-${dd}`;

  const date = new Date(`${normalized}T00:00:00`);

  const options = {
    day: '2-digit',
    month: 'short',
    year: '2-digit',
  };

  const optionsLong = {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  };

  const optionsDefault = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };

  const optionsFull = {
    ...optionsDefault,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  };

  const optionsTime = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  };

  const formatRelative = (date) => {
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    // Future dates
    if (diffInSeconds < 0) {
      return 'Just now';
    }

    const minutes = Math.floor(diffInSeconds / 60);
    const hours = Math.floor(diffInSeconds / 3600);

    // Less than 1 minute
    if (minutes < 1) {
      return 'Just now';
    }

    // Less than 1 hour
    if (minutes < 60) {
      return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
    }

    // Less than 2 hours
    if (hours < 2) {
      return '1 hour ago';
    }

    // Check if today
    const isToday =
      date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      date.getDate() === now.getDate();

    if (isToday) {
      return "today @ " +date.toLocaleTimeString('en-ZM', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });
    }

    // Check if yesterday
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    const isYesterday =
      date.getFullYear() === yesterday.getFullYear() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getDate() === yesterday.getDate();

    if (isYesterday) {
      const time = date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });

      return `Yesterday at ${time}`;
    }

    // Same year
    if (date.getFullYear() === now.getFullYear()) {
      const formattedDate = date.toLocaleDateString('en-US', {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
      });

      const time = date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });

      return `${formattedDate} @ ${time}`;
    }

    // Previous year
    return 'Last Year';
  };

  switch (format) {
    case 'short':
      return date.toLocaleDateString('en-US', options);

    case 'long':
      return date.toLocaleDateString('en-US', optionsLong);

    case 'full':
      return dateObj.toLocaleString('en-US', optionsFull);

    case 'time':
      return dateObj.toLocaleString('en-US', optionsTime);

    case 'relative':
      return formatRelative(dateObj);

    case 'default':
      return date.toLocaleDateString('en-US', optionsDefault);

    case 'input':
      return normalized;

    default:
      return date.toLocaleDateString('en-US', optionsDefault);
  }
};

export default formatDate;